let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("38sfA"), load("awkVi"), load("h4OCL"), load("6yRq3"), load("ktSfi"), load("9GZ76")]).then(() => parcelRequire('lOGNR'));